const phoneSuccessMessage = document.querySelector(".phone_success_message");
const phoneErrorMessage = document.querySelector(".phone_error_message");
const SHOPIFY_STOREFRONT_TOKEN = document.getElementById('customer-email').dataset.token;
const SHOPIFY_STOREFRONT_GRAPHQL = `https://${window.location.hostname}/api/2023-07/graphql.json`;

export async function updatePhone() {
    const newPhone = document.getElementById('new_phone').value;
    const accessToken = window.localStorage.getItem("ShopifyCustomerToken");
    
    if (!accessToken) {
      console.error('Customer access token is missing');
      return;
    }
    
    const mutation = `
        mutation customerUpdate($customerAccessToken: String!, $customer: CustomerUpdateInput!) {
        customerUpdate(customerAccessToken: $customerAccessToken, customer: $customer) {
            customer {
                id
                phone
            }
            customerUserErrors {
                code
                field
                message
            }
        }
        }
    `;
    
    const response = await fetch(`${SHOPIFY_STOREFRONT_GRAPHQL}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': SHOPIFY_STOREFRONT_TOKEN,
      },
      body: JSON.stringify({
        query: mutation,
        variables: {
          customerAccessToken: accessToken,
          customer: {
            phone: newPhone,
          },
        },
      }),
    });
    
    const data = await response.json();
    if (data.errors || data.data.customerUpdate.customerUserErrors.length) {
        console.error('Error updating phone number:', data);
        phoneSuccessMessage.classList.remove("active");
        phoneErrorMessage.classList.add("active");
        if (data.errors) {
            phoneErrorMessage.textContent = data.errors[0].message;
        }
    } else {
        phoneErrorMessage.classList.remove("active");
        phoneSuccessMessage.classList.add("active");
    }
}